/* eslint-disable @next/next/no-img-element */

import { CustomEventName, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import { styled } from '@linaria/react';
import { CSSProperties, FC } from 'react';

export type TabProps = {
  url?: string;
  icon: string;
  isButton?: boolean;
  onAction?: () => void;
  onResize?: (size?: boolean) => void;
  key?: string;
  isDesktop?: boolean;
  id?: string;
  wrapperStyle?: CSSProperties;
  imageStyle?: CSSProperties;
  gtmEvent?: {
    [GTMEventKey.EVENT_NAME]: CustomEventName;
    [GTMEventKey.SECTION]: string;
    [GTMEventKey.CLICK_ITEM]: string;
  };
};

const Tab = styled.button`
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: height 0.15s ease-out;
  cursor: pointer;

  img {
    width: 36px;
    height: 36px;

    @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
      width: 24px;
      height: 24px;
    }
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ShareIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    width: 36px;
    height: 36px;

    @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
      width: 24px;
      height: 24px;
    }
  }
`;

const ShareTab: FC<TabProps> = ({
  url = '',
  icon = '',
  isButton = false,
  onAction,
  id = '',
  wrapperStyle = {},
  imageStyle = {},
  gtmEvent
}) => {
  const onClick = () => {
    if (!gtmEvent) return;
    sendGTM(gtmEvent);
    if (isButton && onAction) {
      onAction();
    }
  };

  if (isButton) {
    return (
      <Tab onClick={onClick}>
        <ButtonWrapper style={wrapperStyle}>
          <img id={id} src={icon as string} alt='tab-icon' style={imageStyle} />
        </ButtonWrapper>
      </Tab>
    );
  }

  return (
    <ShareIcon href={url} onClick={onClick}>
      <img src={icon} alt='tab-icon' />
    </ShareIcon>
  );
};

export default ShareTab;
